import React from 'react';

const Inicio = () => {
  return <div className="op-component"></div>;
};

export default Inicio;
